import { render, staticRenderFns } from "./TeacherCheckAnswerPopup.vue?vue&type=template&id=16f4fb7a"
import script from "./TeacherCheckAnswerPopup.vue?vue&type=script&lang=js"
export * from "./TeacherCheckAnswerPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports